import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The configured prefix is required for caller classes to override conflicting base utilities.
const twMerge = extendTailwindMerge({ prefix: "tw-" });

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
